import axios from "axios";
import Vue, { App, Plugin } from "vue";
import AUApi from "@/api";
import { isTablet, isPhone, isWeb } from "@/DeviceInfoPlugin";
import { Globals, StaticGlobals } from "@/Globals";
import {
    begriffBezeichnung, begriffAic, begriffTooltip, globalsAic, globalsKennung, globalsStt, globalsFrame, globalsAufgaben,
    globalsLayout, globalsDruck, globalsModellFarbe
} from "@/local";

export const OurPlugin: Plugin = {
    install: (app: App, ...options: any[]) => {
        // inject a globally available $translate() method
        // app.config.globalProperties.$translate = (key: string) => {
        //     // retrieve a nested property in `options`
        //     // using `key` as the path
        //     return key.split('.').reduce((o, i) => {
        //         if (o) return o[i]
        //     }, options)

        // export default function OurCommonPlugin<T>(vue: typeof Vue, options?: T): void {
        app.config.globalProperties.$api = AUApi.Current;

        app.config.globalProperties.begriffBezeichnung = (s: string): string =>
            begriffBezeichnung(s);
        app.config.globalProperties.$begriffAic = (s: number): string => begriffAic(s);
        app.config.globalProperties.$begriffTooltip = (s: string): string =>
            begriffTooltip(s);
        app.config.globalProperties.Globals = Globals;
        app.config.globalProperties.$globalsAic = (type: Globals, aic: number): string =>
            globalsAic(type, aic);
        app.config.globalProperties.$globalsKennung = (
            type: Globals,
            kennung: string,
            warn: boolean = true
        ): string => globalsKennung(type, kennung, warn);
        (window as any).Globals = Globals;
        app.config.globalProperties.globalsBezeichnung = (
            type: Globals,
            kennung: string,
            alt: string | null = null
        ): string => {
            const x = globalsKennung(type, kennung, false);
            if (x && x.bezeichnung) {
                return x.bezeichnung;
            }
            if (!alt) {
                return kennung;
            }
            return alt;
        };
        app.config.globalProperties.$globalsBegriffMemo = (
            type: Globals,
            kennung: string,
            alt: string | null = null
        ): string => {
            const x = globalsKennung(type, kennung, false);
            if (x?.memo) {
                return x.memo;
            }
            if (!alt) {
                return x.bezeichnung;
            }
            return alt;
        };
        app.config.globalProperties.$globalsModellFarbe = (
            type: Globals,
            kennung: string,
            alt: string | null = null
        ): string => {
            const x = globalsKennung(type, kennung, false);
            if (x && x.farbe) {
                return x.farbe;
            }
            if (!alt) {
                return kennung;
            }
            return alt;
        };
        // Modelle & Formulare können nur bei Mobilen geräten aktiv sein!
        app.config.globalProperties.$globalsBegriffMobile = (
            type: Globals,
            kennung: string,
            alt: string | null = null
        ): string => {
            const x = globalsKennung(type, kennung, false);
            if (x) {
                return x.alias;
            }
            if (!alt) {
                return "null";
            }
            return alt;
        };
        app.config.globalProperties.$globalsBegriffCache = (
            type: Globals,
            kennung: string,
            alt: string | null = null
        ): string => {
            const x = globalsKennung(type, kennung, false);
            if (x) {
                return x.SbRefresh as string;
            }
            if (!alt) {
                return "null";
            }
            return alt;
        };
        app.config.globalProperties.$globalsStt = (type: Globals, stt?: number, kennung?: string, noFilter?: boolean): string =>
            globalsStt(type, stt, kennung, noFilter);
        app.config.globalProperties.$globalsDruck = (type: Globals, pers: boolean, stammtyp: any, aic?: boolean, aicDruck?: number):
            string => globalsDruck(type, pers, stammtyp, aic, aicDruck);
        app.config.globalProperties.$globalsFrame = (type: Globals, pers: boolean, stammtyp?: any, name?: string,
            standard?: boolean, kennung?: string): string =>
                globalsFrame(type, pers, stammtyp, name, standard, kennung);
        app.config.globalProperties.$globalsLayout = (type: Globals): string =>
            globalsLayout(type);
        app.config.globalProperties.$globalsAufgabe = (pers: boolean): string =>
            globalsAufgaben(pers);


        app.config.globalProperties.$isTablet = () => isTablet();
        app.config.globalProperties.$isPhone = () => isPhone();
        app.config.globalProperties.$isWeb = () => isWeb();

    }
}

